import { IAuth } from "../auth/auth";
import { Axios } from "../axios";

export const getTransactionHistory = async (body: IAuth.IHistoryTrxnPageProps) => {
  const { page, size, ascending, filter, fromDate, toDate } = body;
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/user/${currentUser.vendor_key}/transactions`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
      params: {
        pageNumber: page,
        pageSize: size,
        ascending: ascending,
        filter: filter,
        fromDate: fromDate,
        toDate: toDate,
      },
    });
  }
};

export const getDownlaodPAN = async (docPath: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/everest/${currentUser.vendor_key}/OFFLINE/document`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
      params: {
        docPath: docPath,
      },
    });
  }
};

export const getTransactionHistoryOther = async (body: IAuth.IHistoryTrxnPageProps) => {
  const { page, size, ascending, filter, fromDate, toDate, tab } = body;
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/user/${currentUser.vendor_key}/offlineTransaction/${tab}`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
      params: {
        pageNumber: page,
        pageSize: size,
        ascending: ascending,
        filter: filter,
        fromDate: fromDate,
        toDate: toDate,
      },
    });
  }
};

export const shareHistoryPageDocs = async (body: {
  selectedTransaction: string;
  userKey: string;
  mode: string;
  selectedValue: string[];
}) => {
  const { selectedTransaction, userKey, mode, selectedValue } = body;
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    // Join the selectedValue array into a comma-separated string
    const docsString = selectedValue.join(",");

    // Manually construct the query string
    const queryString = `transactionNumber=${selectedTransaction}&userKey=${userKey}&mode=${mode}&docs=${docsString}`;
    return await Axios.post(
      `/remit/user/${currentUser.vendor_key}/share/docs?${queryString}`,
      {},
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      }
    );
  }
};

export const getTransactionDocx = async ({
  vendorKey,
  selectedTransaction,
  docPath,
}: IAuth.IDownloadKYCDocsProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/everest/${vendorKey}/${selectedTransaction}/document`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
      params: {
        docPath: docPath,
      },
    });
  }
};

export const getTransactionData = async (transactionNo: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/user/${currentUser.vendor_key}/${transactionNo}`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const getComments = async (transactionNo: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/everest/comments/${transactionNo}`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const postNewUTRNum = async (data: { utr_num?: string; transaction_num?: string }) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post(`/remit/user/${currentUser.vendor_key}/paymentRefrenceNum`, data, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const getPaymentDetails = async (currentUser: IAuth.IIsAuthorisedProps, txnNo?: string) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `/remit/user/${currentUser.vendor_key}/transaction/${txnNo}/getPaymentDetails`,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      }
    );
  }
};

export const uploadDocs = async (
  currentUser: IAuth.IIsAuthorisedProps,
  txnNo: string,
  body: any
) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post(
      `/remit/user/${currentUser.vendor_key}/transaction/${txnNo}/transactionDoc`,
      body,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      }
    );
  }
};

export const downloadOtherKycDocx = async (
  currentUser: IAuth.IIsAuthorisedProps,
  txnNo: string,
  docPath: string
) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/user/${currentUser.vendor_key}/${txnNo}/document`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
      // responseType: "blob",
      params: {
        docPath: docPath,
      },
    });
  }
};

export const downloadPdf = async (
  currentUser: IAuth.IIsAuthorisedProps,
  txnNo: string,
  doc: any
) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `/remit/user/${currentUser.vendor_key}/transaction/${txnNo}/getPDF/${doc}`,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
        responseType: "blob",
      }
    );
  }
};

export const getTxnDownload = async (currentUser: IAuth.IIsAuthorisedProps, txnNo: string) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `/remit/user/${currentUser.vendor_key}/transaction/${txnNo}/getPDF/RECEIPT`,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
          "Access-Control-Allow-Origin": "true",
          "Content-Type": "application/pdf",
          // 'partner-type': partner,
        },
        responseType: "blob",
      }
    );
  }
};

export const deleteTransaction = async (currentUser: IAuth.IIsAuthorisedProps, txnId: string) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.delete(
      `/remit/user/${currentUser.vendor_key}/transaction/${txnId}/cancelTransaction`,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
          platform: "k2",
        },
      }
    );
  }
};

export const downloadTransactionHistory = async (
  currentUser: IAuth.IIsAuthorisedProps,
  fromDate: string,
  toDate: string
) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `/remit/user/${currentUser.vendor_key}/getTransactionHistoryDashboard/export/excel`,
      {
        responseType: "blob",
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
        params: {
          fromDate: fromDate,
          toDate: toDate,
        },
      }
    );
  }
};

export const downloadOtherTransactionHistory = async (
  body: { fromDate: string; toDate: string; tab: string },
  currentUser: { vendor_key: string; idToken: string }
) => {
  const { fromDate, toDate, tab } = body;
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `/remit/user/${currentUser.vendor_key}/download/offlineTransaction/${tab}`,
      {
        responseType: "blob",
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
        params: {
          fromDate: fromDate,
          toDate: toDate,
        },
      }
    );
  }
};

export const downloadDocumentHistoryPage = async ({
  vendorKey,
  value,
  selectedTransaction,
}: IAuth.IDownloadDocsProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/everest/download/${vendorKey}/${value}`, {
      responseType: "blob",
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
      params: {
        transactionId: selectedTransaction,
        isRemit: true,
      },
    });
  }
};

export const getTransactionRemarks = async (
  currentUser: IAuth.IIsAuthorisedProps,
  txnNo: string
) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/user/transactionRemark/${txnNo}`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const submitRemark = async (
  currentUser: IAuth.IIsAuthorisedProps,
  txnNo: string,
  body: any
) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post(
      `/remit/user/${currentUser.vendor_key}/transactionRemark/${txnNo}`,
      body,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      }
    );
  }
};

export const getTransactionHistoryConvera = async (body: IAuth.IHistoryTrxnPageProps) => {
  const { page, size, ascending, filter, fromDate, toDate, tab } = body;
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/user/${currentUser.vendor_key}/transactions/convera`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
      params: {
        pageNumber: page,
        pageSize: size,
        ascending: ascending,
        filter: filter,
        fromDate: fromDate,
        toDate: toDate,
      },
    });
  }
};
